/**
 * View component for /user-profiles
 *
 * Generic userProfile list view. Defaults to 'all' with:
 * this.props.dispatch(userProfileActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as userProfileActions from '../userProfileActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import userProfile components
import UserProfileLayout from '../components/UserProfileLayout.js.jsx';
import UserProfileListItem from '../components/UserProfileListItem.js.jsx';

// import userProfile css modules
import userProfileStyles from '../userProfileModuleStyles.css';

class UserProfileList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(userProfileActions.fetchListIfNeeded()); // defaults to 'all'
  }

  render() {
    const { userProfileStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the userProfileList meta info here so we can reference 'isFetching'
    const userProfileList = userProfileStore.lists ? userProfileStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual userProfile objetcs
     */
    const userProfileListItems = userProfileStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !userProfileListItems || !userProfileList;

    return (
      <UserProfileLayout>
        <div className="flex">
          <Helmet
            title={"User Profiles | Pro-ficiency"}
          />
          <section className="section">
            <div className="yt-container">
              <h1> User Profile List
                <Link className="yt-btn small u-pullRight" to={'/user-profiles/new'}> NEW User Profile </Link>
              </h1>
              <hr/>
              { isEmpty ?
                (userProfileListItems && userProfileList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: userProfileList.isFetching ? 0.5 : 1 }}>
                  <ul>
                    {userProfileListItems.map((userProfile, i) =>
                      <UserProfileListItem key={userProfile._id + i} userProfile={userProfile} />
                    )}
                  </ul>
                </div>
              }
            </div>
          </section>
        </div>
      </UserProfileLayout>
    )
  }
}

UserProfileList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    userProfileStore: store.userProfile
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UserProfileList)
);



// WEBPACK FOOTER //
// modules/userProfile/views/UserProfileList.js.jsx